import type { IconProps } from './types';

const CheckSquareFilledIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M24 24H0V0H24V24ZM9.87988 14.5244L7.4541 12.0938L5.83984 13.7119L10.0693 17.9512L18.5068 7.38184L16.7236 5.95117L9.87988 14.5244Z"
        fill={color}
      />
    </svg>
  );
};

export { CheckSquareFilledIcon };
